import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Actividad } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityActividadesAdapter: EntityAdapter<Actividad> =
  createEntityAdapter<Actividad>({
    selectId: (model) => model.id,
    sortComparer: (a: Actividad, b: Actividad): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityActividadesState extends EntityState<Actividad> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityActividadesState =
  entityActividadesAdapter.getInitialState({
    isLoading: false,
    error: null
  });
